export default __webpack_public_path__ + "static/media/image_20.cd4686b1.jpg";